import React from 'react'
import { useTranslation } from 'react-i18next'
import { Button, Divider, List } from '@fs/zion-ui'
import { ContentAdd } from '@fs/zion-icon'
import { useSlsStateContext } from '@fs/zion-sls'
import Droppable from '../../../../views/indexing/components/ui/Droppable'
import PersonListItem from './PersonListItem'
import { droppableContainerCss, activeBorderCss } from './style.utils'

const RecordGroup = ({ record, dragInfo, handleAddNameClick }) => {
  const [t] = useTranslation()
  const { currentImageArk } = useSlsStateContext()

  const persons = record?.subElements?.filter(
    (sub) => sub?.elementType === 'PERSON' && sub?.partitionKey === currentImageArk
  )

  if (!persons || persons.length === 0) {
    return null
  }

  const getOverStyle = (isOver, over) => {
    if (!dragInfo?.isDragging) {
      return undefined
    }
    if (isOver && over?.id !== dragInfo?.person?.recordId) {
      return activeBorderCss
    }
    return droppableContainerCss
  }

  return (
    <>
      <Divider marginY="xxs" />
      <Droppable id={record?.id} setOverStyle={getOverStyle}>
        <List>
          {persons.map((person) => (
            <PersonListItem key={person?.id} person={person} record={record} dragInfo={dragInfo} />
          ))}
        </List>
        <Button
          emphasis="low"
          size="sm"
          Icon={ContentAdd}
          data-testid={`record-group-add-name-button-${record?.id}`}
          linkName="manage-names-record-group-add-name"
          onClick={() => handleAddNameClick(record?.id)}
        >
          {t('manage-names.add-name', 'NAME')}
        </Button>
      </Droppable>
    </>
  )
}

export default RecordGroup
